document.getElementById('orderSwatchBtn').addEventListener('click', () => {
  const relatedProducts = JSON.parse(document.getElementById('related-products-json').textContent);
  const container = document.getElementById('related-products-container');
  const swatchOverlay = document.getElementById('custom-swatch-overlay');
  container.innerHTML = ''; // Clear existing

 relatedProducts.forEach(product => {
  const addToCartBtn = product.available
    ? `<span class="add-to-cart-swatch"
        data-id="${product.id}"
        data-title="${product.title}"
        data-image="${product.image}">
        ＋
      </span>`
    : '';

  const productHTML = `
    <div class="items-order-swatch">
      <div class="items-order-add">
        <a href="${product.url}">
          <img class="order-images" src="${product.image}" alt="${product.title}" />
        </a>
        ${addToCartBtn}
      </div>
      <div class="order_title">${product.title}</div>
    </div>
  `;

  container.insertAdjacentHTML('beforeend', productHTML);
});

  document.getElementById('swatchModal').style.display = 'block';
  swatchOverlay.classList.add('active');
});

document.addEventListener('click', function(e) {
  if (e.target && e.target.classList.contains('add-to-cart-swatch')) {
    const button = e.target;
    const variantId = e.target.getAttribute('data-id');
    const productTitle = button.getAttribute('data-title');
    const productImage = button.getAttribute('data-image');
    //alert(variantId);
    
    button.disabled = true;
    //button.textContent = '⏳'; // Optional: show loading spinner or hourglass
     e.target.classList.add('loading');
    

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(res => res.json())
    .then(data => {
     button.textContent = '＋';
     e.target.classList.remove('loading');
     button.disabled = true;

    // Add to selected swatches list
      const swatchList = document.getElementById('added-swatches-list');
      const swatchItem = document.createElement('div');
      swatchItem.className = 'swatch-item';
      swatchItem.setAttribute('data-id', variantId);
     
    swatchItem.innerHTML = `
        <img src="${productImage}" alt="${productTitle}">
        <button class="remove-swatch" data-id="${variantId}">✖</button>`;

      swatchList.appendChild(swatchItem);
      document.getElementById('added-swatches').style.display = 'block';
      
    })
    .catch(err => {
      button.textContent = '＋';
      button.disabled = false;
      console.error(err);
    });
  }
  // Remove from swatch list (and optionally cart)
  if (e.target && e.target.classList.contains('remove-swatch')) {
    const variantId = e.target.getAttribute('data-id');
    const item = e.target.closest('.swatch-item');

    if (item) {
      item.remove();
      const swatchList = document.getElementById('added-swatches-list');
     if (swatchList.children.length === 0) {
       document.getElementById('added-swatches').style.display = 'none';
    }
    }

    // OPTIONAL: remove from cart
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    }).catch(err => {
      console.error('Error removing from cart', err);
    });
  }
});

const closeBtn = document.querySelector('.close-swatch');
const swatchModal = document.getElementById('swatchModal');
const swatchOverlay = document.getElementById('custom-swatch-overlay');

closeBtn.addEventListener('click', () => {
  swatchOverlay.classList.remove('active');
});

document.getElementById('custom-swatch-overlay').addEventListener('click', function () {
  document.getElementById('swatchModal').style.display = 'none';
  this.classList.remove('active');
});

